import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { KYMW7002Component } from './kymw7002.component';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { GetApprovalFlowTypeInfoService } from './api-service/get-approval-flow-type-info.service';
import { GetSelectedGoodsFlgResultService } from './api-service/get-selected-goods-flg-result.service';
import { GetCandidateSuggestionGoodsListService } from './api-service/get-candidate-suggestion-goods-list.service';
import { GetSuggestionGoodsInfoService } from './api-service/get-suggestion-goods-info.service';
import { GetSuggestionGoodsListInfoService } from './api-service/get-suggestion-goods-list-info.service';
import { GetSuggestionGoodsListOutputInfoService } from './api-service/get-suggestion-goods-list-output-info.service';
import { RegistSuggestionGoodsInfoService } from './api-service/regist-suggestio-goods-info.service';
import { PricePatternPipe } from './pipes/price-pattern.pipe';
import { OrderUnitTypePipe } from './pipes/order-unit-type.pipe';
import { NewUnitTypePipe } from './pipes/new-unit-type.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    WjNavModule,
    WjGridModule,
    FontAwesomeModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW7002Component,
    PricePatternPipe,
    OrderUnitTypePipe,
    NewUnitTypePipe,
  ],
  providers: [
    GetApprovalFlowTypeInfoService,
    GetSelectedGoodsFlgResultService,
    GetCandidateSuggestionGoodsListService,
    GetSuggestionGoodsInfoService,
    GetSuggestionGoodsListInfoService,
    GetSuggestionGoodsListOutputInfoService,
    RegistSuggestionGoodsInfoService,
  ],
})
export class KYMW7002Module { }
